import React from "react";
import {useParams} from "react-router-dom";
import EntityListRowForm from "../../../../components/Entities/EntityListRowForm";
import {PublicTransitLayerEntityName} from "../../../../api/entities/replancity_PublicTransitLine";
import {EntityServiceName} from "../../../../api/enums/enums";
import EntitiesLoader from "../../../../components/Entities/EntitiesLoader/EntitiesLoader";
import CopyRouteToLineAction from "../ListEntityActionCopyTo/CopyRouteToLineAction";
import TraceRouteToNetwork from "../../../../features/trace-route-to-network/ui/TraceRouteToNetwork";

const ACTIONS = [CopyRouteToLineAction, TraceRouteToNetwork];

const TransitRoutesList = () => {
    const entityName = PublicTransitLayerEntityName.ROUTES;
    const serviceName = EntityServiceName.PUBLIC_TRANSIT;
    const {lineId} = useParams<any>();

    return (
        <EntitiesLoader
            entityName={entityName}
            layerEntityName={entityName}
            serviceName={serviceName}
            parentId={lineId}
            form={EntityListRowForm}
            actions={ACTIONS}
        />
    )
}

export default TransitRoutesList;